module.exports = __webpack_public_path__ + "img/bag-cart.7e1320c4.svg";